__turbopack_context__.v({
  "className": "inter_5352f58b-module__HmUwHW__className",
  "variable": "inter_5352f58b-module__HmUwHW__variable",
});
